import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    flex
    gap-6
    relative
    flex-grow
  `,
  {
    variants: {
      variant: {
        default: 'flex-row',
        stack: 'flex-col relative',
        announcement: 'flex-row',
        left: 'flex-col sm:flex-row',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const bodyStyles = cva(
  `
    flex
    flex-col
    items-start
    gap-4
    flex-grow

  `,
  {
    variants: {
      variant: {
        default: '',
        left: 'pl-6',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const imgBgStyles = cva(
  `
    flex
    justify-center
    border-none
    rounded-2xl
    p-6
    shrink-0
  `
)
